import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=65568631&scoped=true&lang=pug&"
import script from "./slider.vue?vue&type=script&lang=js&"
export * from "./slider.vue?vue&type=script&lang=js&"
import style0 from "./slider.styl?vue&type=style&index=0&id=65568631&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65568631",
  null
  
)

export default component.exports